var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.509,
    height: 13.892,
    viewBox: "0 0 21.509 13.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#208ce1;stroke-miterlimit:10;stroke-width:1.2px;}.a{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.402 0.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.309,
    height: 12.692,
    transform: "translate(0.197)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.3,
    cy: 2.3,
    r: 2.3,
    transform: "translate(8.052 4.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M948.346,594.319s3.713.333,4.711-4.045",
    transform: "translate(-948.346 -590.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M968.623,594.319s-3.714.333-4.711-4.045",
    transform: "translate(-948.346 -590.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M948.346,599.16s3.713-.333,4.711,4.046",
    transform: "translate(-948.346 -590.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M968.623,599.16s-3.714-.333-4.711,4.046",
    transform: "translate(-948.346 -590.273)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeIcon);
export default __webpack_public_path__ + "static/media/fee_icon.22bdd65d7e18236224c12516918808b9.svg";
export { ForwardRef as ReactComponent };